import React from "react";
import { connect } from "react-redux";
import { Pages, PageTabs } from "../../../../../../store/AppDisplays";
import { Filter } from "../../../02-pages/Filter";
import { isRemoteLoading, ReduxState } from "../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { Results } from "../../../02-pages/Results";
import { Partners as PartnerType} from "../../../../../../store/Partners/Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: PartnerType;
}

type Props = StateProps;

/**
 *
 * @param s
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.PARTNER_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.PARTNER_RESULTS),
});

/**
 *
 * @param props
 */
export class PartnersComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <Div style={{marginTop: "-20px"}}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={Pages.PARTNERS}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.MANUAL_BOOKING_CREATE_BOOK_PARTNER}
                    scope={RemoteScope.PARTNER_RESULTS}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const Partners = connect(
    mapStateToProps,
    {},
)(PartnersComp);
